module.exports = __webpack_public_path__ + "static/media/loader.9e0373c2.gif";